import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { CollectionNoteModel } from "./models";

export type SaveCollectionNoteRequest = {
  addressUnitNo: string | undefined;
  addressStreetNo: string | undefined;
  addressStreetName: string | undefined;
  addressSuburbName: string | undefined;
  addressStateCode: string | undefined;
  addressPostCode: string | undefined;
  addressCountry: string | undefined;
  createdAt: Date;
  note: string;
};

export type SaveCollectionNoteResponse = {
  note: CollectionNoteModel;
};

export const saveCollectionNote = async (request: SaveCollectionNoteRequest) => {
  const response = await executeApiRequest(() => axios.post<SaveCollectionNoteResponse>(`/notes`, request), false);

  return response?.data;
};
